var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticStyle:{"width":"100%"}},[(_vm.MQ.mdOrBigger)?[_c('h4',[_vm._v(_vm._s(_vm.$tc('nav.bank.transactions')))])]:_vm._e(),_c('activity-component')],2)}
var staticRenderFns = []

export { render, staticRenderFns }